<template>
  <div class="search-history">
    <template v-if="historyList.length > 0">
      <div class="search-history-title">
        <div class="flex-1">Search records</div>
        <span class="search-history-clear" @click="handleClear">
          <i class="icon-delete"></i>
        </span>
      </div>
      <ul class="search-history-list">
        <li class="search-history-item" v-for="item in historyList" :key="item">
          <router-link
            class="ellipsis"
            :to="getSearchUrl(item)"
            :data-keyword="item"
            @click="handleItemClick('historyrecord', item)"
            >{{ item }}</router-link
          >
          <i
            class="icon-circle-close search-history-item-close"
            @click="handleDel(item)"
          ></i>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { getSearchUrl } from '@/utils';

export default {
  props: {
    historyList: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getSearchUrl,

    handleDel(word) {
      // this.$firebase.academySearchpopupClick({
      //   content: 'delete',
      // });
      this.$emit('del-history', word);
    },

    handleClear() {
      // this.$firebase.academySearchpopupClick({
      //   content: 'clearall',
      // });
      this.$emit('clear-history');
    },

    handleItemClick(content, keyword) {
      // this.$emit('set-focus');
      // console.log('set-focus');
      // this.$firebase.academySearchpopupClick({
      //   content,
      //   searchkey: keyword,
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO
@import '@/styles/mixin.scss';
.search-history {
  @include dropdown-style();

  &-title {
    height: 30px;
    display: flex;
    padding: 0 8px 0 10px;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 12px;
    line-height: 30px;
    color: var(--current-default-color);
    font-weight: 600;
    justify-content: space-between;
    align-items: center;
  }

  &-clear {
    // @include flex-align-center();
    cursor: pointer;
    color: #868e9c;
    font-size: 12px;
    font-weight: normal;
    border-radius: 2px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;

    &:hover {
      background-color: var(--current-bg-hover-color);
    }

    > i {
      font-size: 14px;
      cursor: pointer;
    }
  }

  &-item {
    @include flex-align-center();
    position: relative;
    padding: 0 13px 0 10px;
    list-style: none;
    line-height: 36px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      background: var(--current-bg-hover-color);
    }

    > a {
      flex: 1;
      padding-right: 24px;
      padding-left: 1px;
      box-sizing: border-box;
      color: var(--current-search-item-color);
      font-size: 12px;
    }

    &-close {
      display: none;
      cursor: pointer;
      font-size: 14px;
      color: var(--current-search-history-delete-color);
    }

    &:hover {
      .search-history-item-close {
        display: inline-block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page-navbar/search/history.vue